module.exports = __webpack_public_path__ + "img/logo_holcim.4ab49b4b.png";